import { QueryClient, useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import User from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/User";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import { QueryKeyFactory } from "../services/queryKeys";
import UserService from "../services/UserService";
import { unwrap } from "../utils/queryFn";
import { TABLE_QUERY_STALE_TIME } from "../utils/tableQuery";

export const userKeys = new QueryKeyFactory(UserService.path);

/** Logged ops user, shared with the profile, time off, work logs, and the dashboard. */
export function fetchOpsUserByCoreId(client: QueryClient, coreUserId: string): Promise<EnsolversOpsUser> {
  return client.fetchQuery({
    queryKey: userKeys.detail(`core:${coreUserId}`),
    queryFn: () => unwrap(UserService.findByCoreUserId(coreUserId)),
    staleTime: TABLE_QUERY_STALE_TIME,
  });
}

const useUserInfo = () => {
  const [user, setUser] = useState<User | undefined>(undefined);
  const coreUserId = user?.externalId;

  const userQuery = useQuery({
    queryKey: userKeys.detail(`core:${coreUserId ?? "anonymous"}`),
    queryFn: () => unwrap(UserService.findByCoreUserId(coreUserId!)),
    enabled: !!coreUserId,
    staleTime: TABLE_QUERY_STALE_TIME,
  });

  const opsUser = userQuery.data;

  const updateLoggedUser = useCallback(async (loggedUser: User | undefined) => {
    setUser(loggedUser);
  }, []);

  const isUserLoaded = useCallback(() => {
    return user !== undefined;
  }, [user]);

  return {
    user,
    opsUser,
    isUserLoaded,
    updateLoggedUser,
  };
};

export default useUserInfo;
